<template>
  <div class="head">
    <div class="main">
      <div class="logo">
        <a href="javascirpt:void(0)">
          <img class="logo-img" src="../../assets/隆携logo.png" alt="logo" />
        </a>
      </div>
      <div class="con">
        <!-- :default-active="$route.path" -->
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          background-color="#fff"
          text-color="#0066FF"
          active-text-color="#545c64"
        >
          <el-menu-item index="home">首页</el-menu-item>
          <el-menu-item index="enterprise">关于隆携</el-menu-item>
          <el-menu-item index="product">产品介绍</el-menu-item>
          <el-menu-item index="news">新闻资讯</el-menu-item>
          <el-menu-item index="creditColumn">征信专栏</el-menu-item>
          <el-menu-item index="antiMoneyLaundering">反洗钱专栏</el-menu-item>
          <el-menu-item index="consumerProtection">消保专栏</el-menu-item>
          <el-menu-item index="information">信息披露</el-menu-item>
          <el-menu-item index="consulting">消费者权益保护和征信异议受理</el-menu-item>
          <el-menu-item index="forbid">“十不准”</el-menu-item>
          <el-menu-item index="formula">收费标准公示</el-menu-item>
        </el-menu>
      </div>
    </div>
    <FormulaDialog ref="formulaDialogRef"/>
  </div>
</template>

<script>
import FormulaDialog from "@/components/FormulaDialog"

export default {
  name: "Navbar",
  components: { FormulaDialog },
  data() {
    return {
      activeIndex: "",
    };
  },
 async created(){
    this.activeIndex =await JSON.parse(localStorage.getItem('url'))
    console.log('activeIndex',this.activeIndex);
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log('跳转：',key, keyPath);
      if(key === 'formula') {
        this.$refs.formulaDialogRef.openDialog()
        return
      }
      if(key == 'home') this.$emit('notice-change')
      this.$router.push({
        path:`/${key}`})
    },
  },
};
</script>

<style lang="scss" scoped>
.head {
  width: 100%;
  height: 82px;
  background-color: #fff;
  .main {
    width: 100%;
    height: 80px;
    margin: 0 auto;
    display: flex;
    .logo{
      height: 80px;
      background: #fff;
      a{
        img{
          width: 220px;
          height: 80px;
	        image-rendering: -moz-crisp-edges;
	        image-rendering: -o-crisp-edges;
	        image-rendering: -webkit-optimize-contrast;
	        image-rendering: crisp-edges;
	        -ms-interpolation-mode: nearest-neighbor;
        }
      }
    }

    .con{
      .el-menu {
        display: flex;
      .el-menu-item {
        height: 80px;
      }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar/index.vue